// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 162 ? "35a9f203" : chunkId) + "." + {"162":"8cfa8c87b076f4d5","727":"5e50b45259798cfb"}[chunkId] + ".js";
};